// infcode_change - metrics text normalization
export function trimmedText(value: unknown) {
  if (typeof value !== "string") return undefined
  const trimmed = value.trim()
  return trimmed ? trimmed : undefined
}

export function userIdFrom(userInfo: unknown, deviceId: string) {
  const record = objectRecord(userInfo)
  return trimmedText(record?.name) ?? deviceId
}

export function objectRecord(value: unknown): Record<string, unknown> | undefined {
  if (!value || typeof value !== "object" || Array.isArray(value)) return undefined
  return value as Record<string, unknown>
}
